var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1743_2222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 45.9995C35.7025 45.9995 46 35.7021 46 22.9995C46 10.297 35.7025 -0.000488281 23 -0.000488281C10.2975 -0.000488281 0 10.297 0 22.9995C0 35.7021 10.2975 45.9995 23 45.9995Z",
    fill: "#007AB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7421 24.8507V34.3331H31.2445V25.4862C31.2445 23.2649 30.4507 21.7479 28.4602 21.7479C26.9412 21.7479 26.0388 22.7692 25.6402 23.7581C25.4955 24.1115 25.4582 24.6023 25.4582 25.098V34.3327H19.9601C19.9601 34.3327 20.0339 19.349 19.9601 17.798H25.4586V20.1411C25.4475 20.1596 25.432 20.1776 25.4221 20.1952H25.4586V20.1411C26.1892 19.0169 27.4922 17.4097 30.4134 17.4097C34.0304 17.4097 36.7421 19.7729 36.7421 24.8507ZM14.2087 9.82764C12.3281 9.82764 11.0977 11.0621 11.0977 12.6841C11.0977 14.2716 12.2924 15.5418 14.1366 15.5418H14.1722C16.0898 15.5418 17.282 14.2716 17.282 12.6841C17.2456 11.0621 16.0898 9.82764 14.2087 9.82764ZM11.4244 34.3331H16.9204V17.798H11.4244V34.3331Z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1743_2222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2b303cd0598d6e61013533cca94713cc.svg";
export { ForwardRef as ReactComponent };